import { GridFilterItem, GridFilterModel, GridSortModel } from '@mui/x-data-grid';

export function getOrderbyQueryParam(
  sortModel: GridSortModel | undefined,
  excludeAND?: boolean,
  excludeOrderby?: boolean
) {
  if (!sortModel || sortModel.length === 0) {
    return '';
  }

  let prefix = '';
  if (!excludeOrderby) {
    prefix += excludeAND ? '' : '&';
    prefix += '$orderby=';
  }

  const orderByString = sortModel.map((sortItem) => `${sortItem.field} ${sortItem.sort}`).join(',');

  return `${prefix}${orderByString}`;
}

export function getFilterQueryParam(
  filterModel: GridFilterModel | undefined,
  excludeFilterPrefix?: boolean,
  excludeFilterBy?: boolean
) {
  if (!filterModel?.items?.length) return '';

  const filterItems: string[] = [];

  filterModel?.items?.forEach((filterItem: GridFilterItem) => {
    const operator = filterItem.operator;
    const field = filterItem.field;
    let value = filterItem.value;

    if (typeof value === 'string') {
      value = value.replace(/'/g, "''");
    }

    let filter = '';
    switch (operator) {
      case 'contains':
      case 'startsWith':
      case 'endsWith':
        if (!value) {
          break;
        }
        filter = `${operator}(toLower(${field}), toLower('${value}'))`;
        break;
      case 'doesNotContain':
        if (!value) {
          break;
        }
        filter = `not contains(toLower(${field}), toLower('${value}'))`;
        break;
      case 'equals':
        if (!value) {
          break;
        }
        filter = `${field} eq '${value}'`;
        break;
      case '=':
      case 'is':
        if (!value) {
          break;
        }
        filter = `${field} eq ${value}`;
        break;
      case '!=':
      case 'not':
        filter = `${field} ne ${value}`;
        break;
      case '<':
      case 'before':
        if (!value) {
          break;
        }
        filter = `${field} lt ${value}`;
        break;
      case '>':
      case 'after':
        if (!value) {
          break;
        }
        filter = `${field} gt ${value}`;
        break;
      case '>=':
      case 'onOrAfter':
        if (!value) {
          break;
        }
        filter = `${field} ge ${value}`;
        break;
      case '<=':
      case 'onOrBefore':
        if (!value) {
          break;
        }
        filter = `${field} le ${value}`;
        break;
      case 'isEmpty':
        filter = `${field} eq null`;
        break;

      case 'isNotEmpty':
        filter = `${field} ne null`;
        break;
    }

    if (filter) {
      filterItems.push(filter);
    }
  });

  const filterString = filterItems?.join(` ${filterModel.logicOperator ?? 'and'} `);
  if (!filterString) {
    return '';
  }
  if (excludeFilterPrefix) {
    return filterString;
  }

  return `${excludeFilterBy ? '' : `&$filter=`}${filterString}`;
}

export function getSkipQueryParam(skip: number | undefined) {
  return skip === undefined ? '' : `&$skip=${skip}`;
}

export function getTopQueryParam(top: number | undefined) {
  return top === undefined ? '' : `&$top=${top}`;
}

type CombineFiltersParams = {
  filters: (string | undefined)[];
  operator: 'and' | 'or';
};
export const combineFilters = ({ filters, operator }: CombineFiltersParams) => {
  // Filter out undefined filters
  const validFilters = filters
    .filter((filter) => filter && Boolean(filter?.length))
    ?.map((filter) => filter?.replace(/^&\$filter=/, '').trim()); // Remove '&$filter=' and trim any whitespace;

  // Combine filters using the specified logical operator
  let combinedFilters = validFilters.join(` ${operator} `);

  combinedFilters = encodeURIComponent(combinedFilters);

  return `&$filter=(${combinedFilters})`;
};
